import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  ctnModal: {
    width: 280,
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    top: "35%",
    margin: "auto",
    borderRadius: "20px",
    overflow: "hidden",
    outline: "none",
    "& > #padding-content": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 28px",
      paddingBottom: 0,
      "& > #banner-icon": {
        width: "150px",
        objectFit: "contain",
      },
      "& > span": {
        textAlign: "center",
      },
      "& > #title": {
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "24px",
        marginTop: "6px",
      },
      "& > #desc": {
        lineHeight: "20px",
        fontSize: "15px",
        marginTop: "4px",
      },
    },
  },
  btnClose: {
    width: "100%",
    background: '#403DE3 !important',
    borderTopLeftRadius: "0px !important",
    borderTopRightRadius: "0px !important",
    borderBottomLeftRadius: "20px !important",
    borderBottomRightRadius: "20px !important",
    height: "52px",
    marginTop: "30px !important",
    "& > .MuiButton-label": {
      fontWeight: "bold !important",
      textTransform: "none",
      color: "#fff",
    },
  },

  middleWidth: {
    [theme.breakpoints.up("sm")]: {
      width: "380px !important",
    },
  },
  txtAloneTitle: {
    fontSize: "15px !important",
  },
}));

export default useStyles;
